import { useState, useEffect } from "react";
import { AdminAuthContext } from "./context";
import { AdminAuthResponse } from "../../services/admin/admin.service";
import { clearLocalStorageExcept } from "@/utils/localStorageUtils";
import { destroyJivoChat } from "@/utils/jivoChat";

export function AdminAuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<AdminAuthResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("admin_user");
    const storedToken = localStorage.getItem("admin_token");
    const storedRefreshToken = localStorage.getItem("admin_refresh_token");

    if (storedUser && storedToken && storedRefreshToken) {
      setUser({
        ...JSON.parse(storedUser),
        accessToken: storedToken,
        refreshToken: storedRefreshToken,
      });
    }
    setIsLoading(false);
  }, []);

  const login = (data: AdminAuthResponse) => {
    clearLocalStorageExcept("admin");
    setUser(data);
    localStorage.setItem(
      "admin_user",
      JSON.stringify({
        id: data.id,
        email: data.email,
        firstName: data.firstName,
        lastName: data.lastName,
        role: data.role,
        isActive: data.isActive,
        createdAt: data.createdAt,
        updatedAt: data.updatedAt,
      })
    );
    localStorage.setItem("admin_token", data.accessToken);
    localStorage.setItem("admin_refresh_token", data.refreshToken);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("admin_user");
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_refresh_token");
    destroyJivoChat(); // Clean up JivoChat widget
  };

  return (
    <AdminAuthContext.Provider
      value={{
        user,
        isAuthenticated: !!user,
        isLoading,
        login,
        logout,
      }}
    >
      {children}
    </AdminAuthContext.Provider>
  );
}
